<div class="card">
  <div class="card-content px-3">
    <div class="voucher-item d-lg-flex">
      <h5 class="mt-0 mb-lg-0 mb-3 pt-lg-1 text-primary text-uppercase">
        {{ 'voucher.title' | translate }}
      </h5>
    </div>
    <div class="voucher-item">
      <span class="input-group">
        <input
          type="text"
          [(ngModel)]="voucherCode"
          placeholder="INSERT CODE HERE"
          class="form-control text-center px-5 px-lg-0 font-size-14 bg-white"
          (keyup.enter)="redeemVoucher()"
        />
        <div class="input-group-append">
          <button
            class="btn btn-secondary icon text-secondary fw-bold material-icons py-0"
            type="button"
            (click)="redeemVoucher()"
            [disabled]="disableButton"
          >
            <span class="icon material-icons fw-bold font-size-20"> arrow_forward_ios </span>
          </button>
        </div>
      </span>
      <div class="text-center">
        <fgbcl-errors></fgbcl-errors>
      </div>

      <div class="result text-center" *ngIf="redemptionResult">
        <div
          class="font-size-12 mt-1"
          [ngClass]="redemptionResult === 'Code successfully processed' ? 'text-success' : 'text-error'"
        >
          {{ redemptionResult }}
        </div>
      </div>
    </div>
  </div>
</div>
